import { render, staticRenderFns } from "./TrainingLists.vue?vue&type=template&id=6d160337&scoped=true"
import script from "./TrainingLists.vue?vue&type=script&lang=js"
export * from "./TrainingLists.vue?vue&type=script&lang=js"
import style0 from "./TrainingLists.vue?vue&type=style&index=0&id=6d160337&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d160337",
  null
  
)

export default component.exports